<template>
	<select :value="value" class="tbl_select" @change="changePageSize">
		<option value="25">25 per page</option>
		<option value="50">50 per page</option>
		<option value="100">100 per page</option>
		<option value="200">200 per page</option>
	</select>
</template>

<script>
export default {
	props: ['value'],
	methods: {
		changePageSize(event) {
			this.$emit('input', parseInt(event.target.value));
		},
	},
};
</script>

<style></style>
